module.exports = "fonts/poppins-v9-latin-700.woff2";